export const BUSINESS_TYPE = {
  B2C2B: 'b2c2b'
} as const;